import { useCreatePlaylistModalPath } from '..';
import { RouterLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatePlaylistLink = ({
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.createPlaylist"
  }),
  render = (content, to) => /*#__PURE__*/_jsx(RouterLink, {
    to: to,
    children: content
  }),
  trackId,
  lessonId,
  shortId,
  language
}) => {
  const createPlaylistPath = useCreatePlaylistModalPath({
    trackId,
    lessonId,
    shortId,
    language
  });
  return render(children, createPlaylistPath);
};
export default CreatePlaylistLink;